module.exports = __webpack_public_path__ + "static/img/erweima2.8428460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima2.jpg
// module id = f9I+
// module chunks = 1